<template>
  <div>
    <div v-if="row.wave">{{ getWaveDisplayName(row.wave) }}</div>
    <div v-else>-</div>
  </div>
</template>

<script>
export default {
  name: 'tdWave',
  props: ['row'],
  methods: {
    getWaveDisplayName(wave) {
      let name = wave.name;
      if (wave.repSample) {
        name = '(s) ' + name;
      }
      return name;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/OrderTable/components/tdWave.vue